import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const LANG_MAP = { es: 'es-ES', en: 'en-US', de: 'de-DE' };

export default function VoiceInput({ onAppend }) {
  const { t, i18n } = useTranslation();
  const [listening, setListening] = useState(false);

  const supported = typeof window !== 'undefined' &&
    ('SpeechRecognition' in window || 'webkitSpeechRecognition' in window);

  if (!supported) {
    return (
      <p style={{ fontSize: 12, color: '#8B6355', marginTop: 6, lineHeight: 1.4 }}>
        {t('voiceInput.noSupport')}
      </p>
    );
  }

  const start = () => {
    if (listening) return;
    const SR = window.SpeechRecognition || window.webkitSpeechRecognition;
    const rec = new SR();
    const lang = (i18n.language || 'es').slice(0, 2);
    rec.lang = LANG_MAP[lang] || 'es-ES';
    rec.interimResults = false;
    rec.maxAlternatives = 1;

    setListening(true);

    rec.onresult = (e) => {
      const text = e.results[0][0].transcript;
      onAppend(text);
      setListening(false);
    };
    rec.onerror = () => setListening(false);
    rec.onend = () => setListening(false);

    rec.start();
  };

  return (
    <button
      type="button"
      className="campo-btn"
      onClick={start}
      disabled={listening}
      style={{
        minWidth: 44,
        minHeight: 44,
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        padding: '0 14px',
        background: listening ? '#C0392B' : 'transparent',
        border: `1px solid ${listening ? '#C0392B' : '#FAE0B0'}`,
        borderRadius: 8,
        color: listening ? '#fff' : '#5C3D2E',
        fontSize: 13,
        cursor: listening ? 'default' : 'pointer',
        marginTop: 6,
        animation: listening ? 'voicePulse 1s ease-in-out infinite' : 'none',
        transition: 'background 0.2s, border-color 0.2s, color 0.2s',
      }}
    >
      <span>🎤</span> <span>{listening ? t('voiceInput.listening') : t('voiceInput.button')}</span>
    </button>
  );
}
